import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Gamepad2, User, Trophy, Target, Store, BookOpen, Wallet, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/game", label: "PLAY", icon: Gamepad2, testid: "nav-game" },
  { to: "/leaderboard", label: "RANK", icon: Trophy, testid: "nav-leaderboard" },
  { to: "/tasks", label: "TASKS", icon: Target, testid: "nav-tasks" },
  { to: "/education", label: "LEARN", icon: BookOpen, testid: "nav-education" },
  { to: "/shop", label: "SHOP", icon: Store, testid: "nav-shop" },
  { to: "/wallet", label: "WALLET", icon: Wallet, testid: "nav-wallet" },
  { to: "/profile", label: "PROFILE", icon: User, testid: "nav-profile" },
];

export default function Layout({ children, hideNav = false }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <div className="min-h-screen flex flex-col relative overflow-x-hidden">
      <div className="cb-scanlines" aria-hidden="true" />
      <div className="cb-grain" aria-hidden="true" />

      <div className="max-w-md mx-auto w-full flex flex-col min-h-screen relative z-10">
        {/* Top bar */}
        <header className="flex items-center justify-between px-4 py-3 border-b border-[rgba(46,204,113,0.25)]">
          <div
            onClick={() => nav("/")}
            data-testid="brand-logo"
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-7 h-7 rounded-full bg-[#2ecc71] shadow-[0_0_14px_rgba(46,204,113,0.8)] flex items-center justify-center">
              <span className="text-[10px] font-pixel text-[#0f0f1e]">CB</span>
            </div>
            <span className="font-pixel text-[11px] text-glow-green tracking-wider">
              CRYPTOBOOM
            </span>
          </div>
          {user && user !== false ? (
            <div className="flex items-center gap-2">
              <div
                data-testid="hud-bc-balance"
                className="cb-pill flex items-center gap-1 text-[#f7931a] border-[rgba(247,147,26,0.5)] bg-[rgba(247,147,26,0.08)]"
              >
                <span className="text-[9px]">BC</span>
                <span className="text-[10px] text-glow-gold">
                  {user.boom_credits ?? 0}
                </span>
              </div>
              <button
                onClick={async () => {
                  await logout();
                  nav("/login");
                }}
                data-testid="logout-btn"
                title="Logout"
                className="text-white/50 hover:text-[#2ecc71] transition-colors"
              >
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <button
              onClick={() => nav("/login")}
              data-testid="header-login-btn"
              className="cb-pill"
            >
              Login
            </button>
          )}
        </header>

        {/* Main */}
        <main className="flex-1 pb-24 relative">{children}</main>

        {/* Bottom nav */}
        {!hideNav && user && user !== false && (
          <nav
            className="cb-bottom-nav px-2 py-2 flex justify-between overflow-x-auto no-scrollbar"
            data-testid="bottom-nav"
          >
            {items.map((it) => {
              const Icon = it.icon;
              const isActive = loc.pathname.startsWith(it.to);
              return (
                <NavLink
                  to={it.to}
                  key={it.to}
                  data-testid={it.testid}
                  className={`flex-1 min-w-[52px] flex flex-col items-center gap-1 py-1 ${
                    isActive ? "cb-nav-item active" : "cb-nav-item"
                  }`}
                >
                  <Icon size={16} />
                  <span className="text-[8px]">{it.label}</span>
                </NavLink>
              );
            })}
          </nav>
        )}
      </div>
    </div>
  );
}
